import * as React from 'react';
import {autoprefixer} from 'diy/material-ui/autoprefixer';
import {ColorSwatchItem} from './ColorSwatchItem';

export interface ThemingZonesProps {
    activeZone: number;
    onZoneSelected?(index: number): void;
}

interface ThemingZonesState {
}

/**
 * Harcoded number of theming zones. Most layouts have 5 zones. Layouts with fewer zones
 * will have default colors black/white for remaining undefined zones
 */
const ZONES_COUNT = 5;
const ZONE_CLASS_PREFIX = 'diyfeColor';

const SWATCH_ITEM_SIZE = 30;

export class ThemingZones extends React.Component<ThemingZonesProps, ThemingZonesState> {
    render() {
        let styles = this.getStyles();
        return (
            <div style={styles.container}>{this.renderZones()}</div>
        );
    }

    private getStyles() {
        return {
            container: autoprefixer({
                display: 'flex',
                marginBottom: 10
            }),
            zone: {
                marginRight: 8
            },
            webReset: {
                height: 'auto',
                minHeight: 'auto'
            },
            liveArea: {
                borderRadius: SWATCH_ITEM_SIZE / 2
            }
        };
    }

    private renderZones() {
        let styles = this.getStyles();
        let zones: JSX.Element[] = [];
        for (let i = 0, len = ZONES_COUNT; i < len; i++) {
            let zoneClassName = ZONE_CLASS_PREFIX + i;
            let isActive = this.props.activeZone === i;
            let zone = (
                <div style={styles.zone} key={i} onTouchTap={() => this.props.onZoneSelected(i)}>
                    {/* Live preview area, using web classes */}
                    <div className="diyw" style={styles.webReset}>
                        <div className={zoneClassName} style={styles.liveArea}>
                            <ColorSwatchItem
                                /* Uses color from theming live classes*/
                                color="transparent"
                                checkColor="currentColor"
                                checked={isActive}
                                size={SWATCH_ITEM_SIZE}
                            >
                            </ColorSwatchItem>
                        </div>
                    </div>
                </div>
            );
            zones.push(zone);
        }
        return zones;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/common/ThemingZones.tsx
 **/